import * as benchmark from "./benchmark";
import * as cognitive from "./cognitive";
import * as external from "./external";
import * as generic from "./generic";
import * as guide from "./guide";
import * as order from "./order";
import * as xavier from "./xavier";

export default {
  benchmark,
  cognitive,
  external,
  generic,
  guide,
  order,
  xavier
};
